export enum CreateAccountFlowType {
  signUp = 'signUp',
  signUpByInvitationLink = 'signUpByInvitationLink',
  acceptInviteFromEmail = 'acceptInviteFromEmail',
}
